module.exports = __webpack_public_path__ + "static/media/error.b966f0b4.svg";